import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { HotkeyArtefact } from '../hotkeys.service';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { TranslateModule } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { FormsModule } from '@angular/forms';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatIcon } from '@angular/material/icon';

@Component({
    selector: 'app-hotkeys-popup',
    templateUrl: './hotkeys-popup.component.html',
    styleUrls: ['./hotkeys-popup.component.scss'],
    standalone: true,
    imports: [
        MatDialogTitle,
        MatIcon,
        MatSlideToggle,
        FormsModule,
        MatDialogContent,
        MatTable,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        TranslateModule,
    ],
})
export class HotkeysPopupComponent {

  constructor(public dialogRef: MatDialogRef<HotkeysPopupComponent>,
              @Inject(MAT_DIALOG_DATA) public data:
                  {
                    hotkeysEnabled: boolean,
                    hotkeysMap: Map<string, HotkeyArtefact>,
                    hotkeysPopupHotkey: string
                  },
  ) {
    this.hotkeysEnabled = data?.hotkeysEnabled;
    this.hotkeysMap = data?.hotkeysMap;
    this.hotkeysArr = Array.from(this.hotkeysMap?.keys());
    this.hotkeysPopupHotkey = data.hotkeysPopupHotkey;
    this.tableData = new MatTableDataSource(this.hotkeysArr.map(hotkey => {
      return { key: hotkey, action: this.hotkeysMap.get(hotkey).action };
    }));
  }

  hotkeysEnabled: boolean;
  private hotkeysMap: Map<string, HotkeyArtefact>;
  hotkeysArr: string[];
  hotkeysPopupHotkey: string;

  tableData: MatTableDataSource<{ key: string, action: string }>;
  displayedColumns: string[] = ['action', 'key'];

}
